import { Box, Heading, Text, Grid } from '@chakra-ui/react'
import { FC } from 'react'

import { ITwoInfoCardProps } from '@base/@types/components/Layout/Card/TwoInfo'

const TwoInfoCard: FC<ITwoInfoCardProps> = ({ title, one, two }) => {
  return (
    <Box py={4} borderX="solid 1px" borderColor="gray.100">
      <Heading size="sm" mb={4} textAlign="center">
        {title}
      </Heading>
      <Grid w="100%" templateColumns="repeat(2, 1fr)" gap="24px">
        <Box>
          <Text fontSize="lg" fontWeight="bold" textAlign="center">
            {one[1]}
          </Text>
          <Text
            textTransform="uppercase"
            color="gray.500"
            fontSize="sm"
            textAlign="center"
          >
            {one[0]}
          </Text>
        </Box>
        <Box>
          <Text fontSize="lg" fontWeight="bold" textAlign="center">
            {two[1]}
          </Text>
          <Text
            textTransform="uppercase"
            color="gray.500"
            fontSize="sm"
            textAlign="center"
          >
            {two[0]}
          </Text>
        </Box>
      </Grid>
    </Box>
  )
}

export default TwoInfoCard
